import { Pegasus } from 'corso-types';
import DescriptionList, { Description } from '~/components/DescriptionList';
import { orderEditActionLabel } from '~/utils/enumNameMaps';

export default function DisplayEventOrderEditing({
  params,
}: {
  params: Pegasus.EventOrderEditing['params'];
}) {
  const { editType, editConfirmLabel, editSuccessLabel } = params;

  const configDescriptions: Description[] = [];

  configDescriptions.push({
    term: 'Edit Type',
    details: orderEditActionLabel[editType],
  });

  if (editConfirmLabel) {
    configDescriptions.push({
      term: 'Confirm Message',
      details: editConfirmLabel,
    });
  }

  if (editSuccessLabel) {
    configDescriptions.push({
      term: 'Success Message',
      details: editSuccessLabel,
    });
  }

  if (editType === Pegasus.OrderEditType.CANCEL_ORDER) {
    configDescriptions.push({
      term: 'Notify on Cancellation',
      details: params.shouldNotifyOnCancellation ? 'Yes' : 'No',
    });
  }

  if (editType === Pegasus.OrderEditType.CANCEL_ORDER) {
    configDescriptions.push({
      term: 'Restock on Cancellation',
      details: params.shouldRestockOnCancellation ? 'Yes' : 'No',
    });
  }

  if (
    editType === Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS &&
    params.allowDifferentCountryAddressEdit !== undefined
  ) {
    configDescriptions.push({
      term: 'Allow Country Changes',
      details: params.allowDifferentCountryAddressEdit ? 'Yes' : 'No',
    });
  }

  if (
    editType === Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS &&
    params.shouldRecalculateTaxesOnAddressEdit !== undefined
  ) {
    configDescriptions.push({
      term: 'Recalculate Taxes on Address Edit',
      details: params.shouldRecalculateTaxesOnAddressEdit ? 'Yes' : 'No',
    });
  }

  return (
    <div className="mt-2 flex flex-col gap-4">
      <DescriptionList descriptions={configDescriptions} layoutType="list" />
    </div>
  );
}
